export const getCandidateProfilePath = (candidateId) => {
  if (!candidateId) {
    return '/candidates-list';
  }

  return `/candidates/${encodeURIComponent(String(candidateId))}`;
};
